if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();

      const media_template = this.dataset.mediaTemplate || 'default';
      const update_url = this.dataset.updateUrl != undefined ? JSON.parse(this.dataset.updateUrl) : true;

      this.config = {
        media_template: media_template,
        update_url: update_url
      }

      this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(e) {
      const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

      this.toggleAddButton(true, '');

      if (isCombinedProduct) {
        this.fetchProductSection(targetUrl);
        return;  // Stop execution if false
      }

      this.updateOptions();
      this.updateMasterId();
      this.updatePickupAvailability();
      this.updateInventoryStatus();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '');
        this.setUnavailable();
      } else {
        if (this.config.media_template === 'big-image') {
          this.fetchGallery();
        } else {
          this.updateMedia();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateSaleBadge();

        // For Featured product section
        if (this.config.update_url) {
          this.updateURL();
          this.updateShareUrl();
        }
      }
    }

    combinedListingCheck(e) {
      const currentUrl = window.location.pathname;
      const targetUrl = e.target.dataset.productUrl;
      let isCombinedProduct = false;

      if (targetUrl != undefined && currentUrl != targetUrl) {
        isCombinedProduct = true;
      }

      return { isCombinedProduct, targetUrl };
    }

    async fetchProductSection(newProductUrl) {
      const productElement = this.closest('.main-product');
      const productSectionId = this.dataset.section;
      let params = `section_id=${productSectionId}&`;

      const selectedOptionValues = Array.from(this.querySelectorAll('fieldset input:checked')).map((element) => element.dataset.optionValueId).join(',');
        params += `option_values=${selectedOptionValues}`;

      fetch(`${newProductUrl}?${params}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          productElement.innerHTML = html.querySelector('.main-product').innerHTML;
          window.history.replaceState({ }, '', `${newProductUrl}`);
        });
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    fetchGallery() {
      const productMediaGallerySection = document.querySelector('[data-product-media-gallery]');
      if (!productMediaGallerySection) return;

      const gallerySectionId = productMediaGallerySection.getAttribute('id');

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${gallerySectionId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const gallerySlider = document.getElementById(gallerySectionId);
        const zoomModalBody = document.querySelector(`#modal--zoom-gallery-big-image-gallery .modal-body`);
        const newGallerySlider = html.getElementById(gallerySectionId);
        const newZoomModalBody = html.querySelector(`#modal--zoom-gallery-big-image-gallery .modal-body`);

        if (newGallerySlider && newZoomModalBody && gallerySlider && zoomModalBody) {
          gallerySlider.innerHTML = newGallerySlider.innerHTML;
          zoomModalBody.innerHTML = newZoomModalBody.innerHTML;
        }
      })
      .catch((error) => {
        console.error('There was a problem with the fetch operation:', error);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGridySlider = document.getElementById(`slider-${this.dataset.section}`);
      const thumbnailsGridySlider = document.getElementById(`thumbnail-slider-${this.dataset.section}`);

      if (mediaGridySlider) {
        mediaGridySlider.scrollToSlideByID(
          `item-${this.currentVariant.featured_media.id}`
        );
      }

      if (thumbnailsGridySlider) {
        thumbnailsGridySlider.scrollToSlideByID(`thumbnail-item-${this.currentVariant.featured_media.id}`)
      }

      const isDesktop = window.matchMedia('(min-width: 1024px)').matches;
      const isGrid = mediaGridySlider.dataset.desktopEnabled === 'false' ? true : false;
      if (isDesktop && isGrid) {
        document.getElementById(`item-${this.currentVariant.featured_media.id}`)?.scrollIntoView();
      }
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateSaleBadge() {
      if (!this.currentVariant) return;

      const saleBadge = document.getElementById(`${this.dataset.section}-saleBadge`);
      if (!saleBadge) return;

      const comparePrice = this.currentVariant.compare_at_price;
      const salePrice = this.currentVariant.price;

      if (comparePrice && comparePrice > salePrice) {
        const badgeType = saleBadge.dataset.saleBadgeType || 'default';
        let badgeText = '';

        if (badgeType === 'savings') {
          // Calculate savings amount
          const savingsAmount = comparePrice - salePrice;
          const formattedSavings = Woolman.Utils.formatMoney(savingsAmount);
          badgeText = window.saleBadgeStrings.savings.replace('[amount]', formattedSavings);
        } else if (badgeType === 'percentage') {
          // Calculate discount percentage
          const discountPercentage = Math.floor(((comparePrice - salePrice) / comparePrice) * 100);
          badgeText = window.saleBadgeStrings.percentage.replace('[percentage]', discountPercentage);
        } else {
          // Default badge type
          badgeText = window.saleBadgeStrings.default;
        }

        saleBadge.textContent = badgeText;
        saleBadge.classList.remove('hide');
      } else {
        // Hide badge if no discount
        saleBadge.classList.add('hide');
      }
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateVariantStatuses() {
      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-option')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    updateInventoryStatus() {
      this.productInventoryNode = document.querySelector('[data-product-inventory]');

      if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

      this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
      this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;

      const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant?.id];

      if (!this.currentVariant || !this.currentVariant.inventory_management) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);

        return;
      }

      if (this.currentVariant.inventory_management === 'shopify') {
        if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
        } else {
          this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
          this.toggleIncomingInventory(false);
        }
      }
    }

    toggleInventoryQuantity(show, quantity) {
      if (show === false) {
        this.productInventoryNode.classList.add('hide');
        return;
      }

      this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');

      if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
        this.productInventoryNode.classList.add('inventory-status--low');
        if (this.showQuantityInStock === 'true') {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
        } else {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
        }
      } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
        this.productInventoryNode.classList.add('inventory-status--in-stock');
        if (this.showQuantityInStock === 'true') {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
        } else {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
        }
      } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
        this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
      } else {
        this.productInventoryNode.classList.add('inventory-status--sold-out');
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
      }

      this.productInventoryNode.classList.remove('hide');
    }

    toggleIncomingInventory(show, date) {
      const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
      if (!incomingInventoryNode) return;

      if (show == false && incomingInventoryNode) {
        incomingInventoryNode.classList.add('hide');

        return;
      }

      let string = !date ?
        window.variantStrings.inventory.waiting_for_stock :
        window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

      incomingInventoryNode.classList.remove('hide');
      incomingInventoryNode.firstElementChild.textContent = string;
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html            = new DOMParser().parseFromString(responseText, 'text/html');

          const price           = document.getElementById(`price-${this.dataset.section}`);
          const buyBarInfo      = document.getElementById(`buy-bar-info-${this.dataset.section}`);
          const SKU             = document.getElementById(`Sku-${this.dataset.section}`);
          const new_SKU         = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const new_price       = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const new_buyBarInfo  = html.getElementById(`buy-bar-info-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const big_image       = document.querySelector(`#big-image-${this.dataset.section} picture`);
          const new_big_image   = html.querySelector(`#big-image-${this.dataset.section} picture`);

          if (new_price && price) price.innerHTML = new_price.innerHTML;
          if (new_buyBarInfo && buyBarInfo) buyBarInfo.innerHTML = new_buyBarInfo.innerHTML;
          if (new_big_image && big_image) big_image.innerHTML = new_big_image.innerHTML;
          if (new_SKU && SKU) {
            SKU.innerHTML = new_SKU.innerHTML;
            SKU.classList.toggle('hidden', new_SKU.classList.contains('hidden'));
          }

          if (price) price.classList.remove('hidden');

          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }

    toggleAddButton(disable = true, text) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      const multiplyButtons = productForm.querySelectorAll('.btn--add-multiplier');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
        if (multiplyButtons) {
          multiplyButtons.forEach(button => {
            button.disabled = true;
          });
        }
      } else {
        addButton.removeAttribute('disabled');
        if (this.dataset.isPreorder == 'true') {
          addButtonText.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
        if (multiplyButtons) {
          multiplyButtons.forEach(button => {
            button.removeAttribute('disabled');
          });
        }
      }

      const productForm_BuyBar = document.getElementById(
        `product-form-${this.dataset.section}-product-buy-bar`
      );
      if (productForm_BuyBar) {
        const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
        const addButtonText_BuyBar = productForm_BuyBar.querySelector(
          '[name="add"] > span'
        );

        if (disable) {
          addButton_BuyBar.setAttribute("disabled", "disabled");
          if (text) addButtonText_BuyBar.textContent = text;
        } else {
          addButton_BuyBar.removeAttribute("disabled");
          if (this.dataset.isPreorder == "true") {
            addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
          } else {
            addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
          }
        }
      }
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('hidden');

      const button_BuyBar = document.getElementById(
        `product-form-${this.dataset.section}-product-buy-bar`
      );
      const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = button_BuyBar.querySelector(
        '[name="add"] > span'
      );
      const price_BuyBar = document.getElementById(
        `price-${this.dataset.section}-product-buy-bar`
      );
      if (!addButton_BuyBar) return;
      addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
      if (price_BuyBar) price_BuyBar.classList.add("hidden");
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);
}

if (!customElements.get('variant-radios')) {
  class VariantRadios extends customElements.get('variant-selects') {
    constructor() {
      super();
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });

      this.updateLegends();
    }

    updateLegends() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((fieldset) => {
        const legend = fieldset.querySelector('legend [data-variant-legend]');
        const selectedOption = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        legend.textContent = selectedOption.getAttribute('value');
      });
    }
  }
  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-buy-bar')) {
  class ProductBuyBar extends HTMLElement {
    constructor() {
      "use strict";
      super();

      let classes = { show: "show" };
      let mainProductForm = document.querySelector(".product-form");

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // In view -> Hide bar
              this.classList.remove(classes.show);
            } else if (window.scrollY > 200) {
              // Out of view AND scrolled a little from top -> Show bar
              this.classList.add(classes.show);
            }
          });
        },
        { threshold: 0.25 }
      );

      observer.observe(mainProductForm);

      // This script is loaded in product-template.liquid --> Footer observer after DOM ready
      document.addEventListener("DOMContentLoaded", function () {
        let siteFooter = document.querySelector("footer.footer");
        if (!siteFooter) return;
        observer.observe(siteFooter);
      });
    }
  }
  customElements.define('product-buy-bar', ProductBuyBar);
}

if (!customElements.get('upsell-card')) {
  class UpsellCard extends HTMLElement {
    constructor() {
      super();
      this.select = this.querySelector('select');
      this.image = this.querySelector('.card-media img');

      if (this.select) {
        this.select.addEventListener('change', (event) => {
          const selectedOption = event.target.options[event.target.selectedIndex];
          const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
          if (newImgSrc) { this.updateImage(newImgSrc) }
        });
      }
    }

    updateImage(newImgSrc) {
      if (this.image) {
        this.image.src = newImgSrc;
      }
    }
  }
  customElements.define('upsell-card', UpsellCard);
}